import {
  Disc, Wrench, CircleDot, RefreshCw, Gauge, Cpu, Radio, Zap, BatteryCharging, ShieldAlert,
} from "lucide-react";

const MAP = { Disc, Wrench, CircleDot, RefreshCw, Gauge, Cpu, Radio, Zap, BatteryCharging, ShieldAlert };

export const ICON_NAMES = Object.keys(MAP);

export const ServiceIcon = ({ name, ...props }) => {
  const Icon = MAP[name] || Wrench;
  return <Icon {...props} />;
};
